module.exports = __webpack_public_path__ + "media/site_bg.91d9f13f.webm";